<template>
  <div class="navigation-icon elevation-1 rounded-circle d-flex justify-center align-center">
    <svg v-if="iconType === IconType.SVG" :width="size" :height="size">
      <image :xlink:href="icon" :width="size" :height="size" />
    </svg>
    <div v-else-if="iconType === IconType.IMAGE">
      <img :src="icon" :width="size" :height="size" alt="" />
    </div>
    <div v-else>
      <v-icon color="#795de9">mdi-web</v-icon>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { IconType } from "../types";

interface Props {
  icon: string;
}
const size = 25;
const props = defineProps<Props>();

const iconType = computed(() => {
  const iconValueLowercase = props.icon.toLowerCase();
  if (iconValueLowercase.endsWith(".svg")) return IconType.SVG;
  else if (iconValueLowercase.endsWith(".png") || iconValueLowercase.endsWith(".jpg")) return IconType.IMAGE;
  else return IconType.NONE;
});
</script>
<style scoped>
.navigation-icon {
  width: 48px;
  height: 48px;
}
</style>
